import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGetIpAddressQuery, useLazyTriggerIpAdviceQuery } from "./rj";
import { useLazyTriggerCaesarCopyQuery } from "./caesar";
import { Button, Row, Col, Select, DatePicker, Tabs } from "antd";
import "./App.css";

function App() {
  const [ipValue, setIpValue] = useState("");
  const [date, setDate] = useState("");
  const [triggerIp, triggerIpResults] = useLazyTriggerIpAdviceQuery();
  const [triggerCaesar, triggerCaesarResults] = useLazyTriggerCaesarCopyQuery();
  const [disableButton, setDisableButton] = useState(true);
  const [key, setKey] = useState("1");
  const onChange = (key: string) => {
    console.log(key);
    setKey(key);
  };
  const items = [
    {
      key: "1",
      label: `RJ`,
    },
    {
      key: "2",
      label: `CAESAR`,
    },
  ];
  // const responseObject = [
  //   {
  //     ipAddress: "172.25.10.173",
  //     dateCreated: [2023, 1, 10, 10, 44, 47, 439000000],
  //   },
  //   {
  //     ipAddress: "172.19.20.50",
  //     dateCreated: [2023, 1, 11, 9, 16, 55, 843000000],
  //   },
  //   {
  //     ipAddress: "172.19.20.49",
  //     dateCreated: [2023, 1, 11, 9, 17, 18, 559000000],
  //   },
  //   {
  //     ipAddress: "172.25.10.5",
  //     dateCreated: [2023, 1, 11, 9, 17, 49, 4000000],
  //   },
  // ];
  interface IpAddressI {
    ipAddress: string;
  }
  const data = useGetIpAddressQuery("");
  const ipAdvices = data?.data?.responseObject
    ? data?.data?.responseObject?.map((el: IpAddressI) => ({
        value: el.ipAddress,
        label: el.ipAddress,
      }))
    : [];
  const handleIpValueChange = (value: any) => {
    setIpValue(value.value);
  };
  const onDateChange = (date: any, dateString: string) => {
    setDate(dateString.replaceAll("-", ""));
  };
  useEffect(() => {
    if (ipValue && date) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [ipValue, date]);
  if (triggerIpResults?.data?.isSuccess) {
    toast.success("Settled transaction copy initiated", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  if (triggerIpResults?.error) {
    toast.error(triggerIpResults?.data?.message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  if(triggerCaesarResults?.data?.isSuccess){
    toast.success('Transaction copy initiated', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  return (
    <div className="App">
      <ToastContainer />
      <div className="container">
        <header>NIBSS IDRS IP ADVICE</header>
        <h3>
          This portal serves the purpose of accepting the Advised IP address
          where transactions for the day should be copied.
        </h3>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        {Number(key) === 1 && (
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="space-between"
          >
            <Col span={8}>
              <label className="label">IP Address</label>
              <Select
                showSearch
                labelInValue={true}
                optionFilterProp="children"
                placeholder=" -- Select IP -- "
                size="large"
                style={{
                  width: "100%",
                  textTransform: "capitalize",
                  height: 60,
                  textAlign: "start",
                }}
                filterOption={(input, option) => {
                  return (option?.label?.toLowerCase() ?? "").includes(
                    input.toLowerCase()
                  );
                }}
                filterSort={(optionA, optionB) => {
                  return (optionA?.label?.toLowerCase() ?? "")
                    .toLowerCase()
                    .localeCompare(
                      (optionB?.label?.toLowerCase() ?? "").toLowerCase()
                    );
                }}
                options={[...ipAdvices]}
                onChange={handleIpValueChange}
              />
            </Col>

            <Col span={8}>
              <label className="label">Date</label>
              <DatePicker
                style={{ width: "100%", height: "40px" }}
                onChange={onDateChange}
              />
            </Col>

            <Col span={8}>
              <Button
                type="primary"
                style={{ width: "100%", height: "40px", marginTop: "1.7rem" }}
                onClick={() => triggerIp({ ipValue, date })}
                disabled={disableButton || triggerIpResults.isLoading}
                loading={triggerIpResults.isLoading}
              >
                Trigger
              </Button>
            </Col>
          </Row>
        )}{" "}
        {Number(key) === 2 && (
          <Row>
            <Col span={8}>
              <Button
                type="primary"
                style={{ width: "100%", height: "40px", marginTop: "1.7rem" }}
                onClick={() => triggerCaesar("")}
                loading={triggerCaesarResults.isLoading}
                disabled={triggerCaesarResults.isLoading}
              >
                Trigger
              </Button>
            </Col>
          </Row>
        )}
      </div>
    </div>
  );
}

export default App;
